// React
import React from "react";

import { Link } from "react-router-dom";

// Components
import { Upload, message, Button } from "antd";
import { FileImageTwoTone, UploadOutlined } from '@ant-design/icons';

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// DateTime
const { DateTime } = require("luxon");

const EventCard = React.forwardRef((props, ref) => {
  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    if (timeObject.isValid) {
      const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
      return <p className="indexItem_eventDate">{timeString}</p>;
    } else {
      return <></>;
    }
  }

  // function formatTags(tags) {
  //   if (tags == null || typeof tags === "undefined") {
  //     return <></>;
  //   }
  //   return tags.map((tag, n) => (
  //     <div className="tag" key={tag.tagid}>
  //       <p>{tag.raw}</p>
  //     </div>
  //   ));
  // }

  const uploadProps = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text"
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  var cardImageURL = props.list.eviteimages3resourceuri;
  if (cardImageURL != null && typeof cardImageURL !== "undefined") {
    cardImageURL = EventifyAPI.encodeS3URL(props.list.eviteimages3resourceuri);
  }

  return (
    <Link
      className="event-card"
      to={`/list/${props.list.listid}`}
    >
      <div className={`${cardImageURL != null ? "card-image" : "card-image-no-cap"}`}>
        { cardImageURL == null
          ?
          <>
            <FileImageTwoTone
              twoToneColor="#0a79fb"
              style={{ fontSize: "30px" }}
            />
            <Upload {...uploadProps}>
              <Button
                type="primary"
                ghost
                onClick={(e) => { e.preventDefault() }}
              >
                <UploadOutlined /> Upload Invite
              </Button>
            </Upload>
          </>
        : <></>
        }
        <img src={cardImageURL} alt="" />
      </div>
      <div className="card-title">
        <h3>{props.list.name}</h3>
      </div>
      <div className="card-details">{formatTime(props.list.primaryDate)}</div>
      <div className="card-badge">
        <p>{props.membershipCount}</p>
      </div>

      {/* <div className="card-tags">{formatTags(props.tags)}</div> */}
    </Link>
  );
});

export default EventCard;
